import {command, queryOne, queryPage, querySearch} from "../utils/api";

const GET_FEES_URL = `${process.env.PUBLIC_URL}/api/v1/r/fees`;
export const SEARCH_FEES = 'SEARCH_FEES';
export const SEARCH_FEES_COMPLETED = 'SEARCH_FEES_COMPLETED';
export const SEARCH_FEES_FAILED = 'SEARCH_FEES_FAILED';

export const searchFees = querySearch(GET_FEES_URL, SEARCH_FEES, SEARCH_FEES_COMPLETED, SEARCH_FEES_FAILED,
  ['name', 'lineItemDescription']);

export const GET_FEE = 'GET_FEE';
export const GET_FEE_COMPLETED = 'GET_FEE_COMPLETED';
export const GET_FEE_FAILED = 'GET_FEE_FAILED';

export function getFee({feeId}) {
  return queryOne(GET_FEES_URL, {where: {feeId}}, GET_FEE, GET_FEE_COMPLETED, GET_FEE_FAILED);
}

const FEE_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/fee`;
export const ADD_FEE = 'ADD_FEE';
export const ADD_FEE_COMPLETED = 'ADD_FEE_COMPLETED';
export const ADD_FEE_FAILED = 'ADD_FEE_FAILED';
export const addFee = command(FEE_ACTION_URL + '/add', ADD_FEE, ADD_FEE_COMPLETED, ADD_FEE_FAILED);

export const UPDATE_FEE = 'UPDATE_FEE';
export const UPDATE_FEE_COMPLETED = 'UPDATE_FEE_COMPLETED';
export const UPDATE_FEE_FAILED = 'UPDATE_FEE_FAILED';
export const updateFee = command(FEE_ACTION_URL + '/update', UPDATE_FEE, UPDATE_FEE_COMPLETED, UPDATE_FEE_FAILED);

const GET_FEE_RATES_URL = `${process.env.PUBLIC_URL}/api/v1/r/feesRates`;
export const GET_FEE_RATES = 'GET_FEE_RATES';
export const GET_FEE_RATES_COMPLETED = 'GET_FEE_RATES_COMPLETED';
export const GET_FEE_RATES_FAILED = 'GET_FEE_RATES_FAILED';

export function getFeeRates({feeId, pagination}) {
  return queryPage(GET_FEE_RATES_URL, {
    where: {feeId},
    order: 'rateId ASC'
  }, GET_FEE_RATES, GET_FEE_RATES_COMPLETED, GET_FEE_RATES_FAILED, pagination);
}

export const ADD_FEE_RATE = 'ADD_FEE_RATE';
export const ADD_FEE_RATE_COMPLETED = 'ADD_FEE_RATE_COMPLETED';
export const ADD_FEE_RATE_FAILED = 'ADD_FEE_RATE_FAILED';
export const addFeeRate = command(FEE_ACTION_URL + '/addRate', ADD_FEE_RATE, ADD_FEE_RATE_COMPLETED, ADD_FEE_RATE_FAILED);

const GET_FEE_APPLICABLE_PRODUCTS_URL = `${process.env.PUBLIC_URL}/api/v1/r/feesApplicableProducts`;
export const SEARCH_FEE_APPLICABLE_PRODUCTS = 'SEARCH_FEE_APPLICABLE_PRODUCTS';
export const SEARCH_FEE_APPLICABLE_PRODUCTS_COMPLETED = 'SEARCH_FEE_APPLICABLE_PRODUCTS_COMPLETED';
export const SEARCH_FEE_APPLICABLE_PRODUCTS_FAILED = 'SEARCH_FEE_APPLICABLE_PRODUCTS_FAILED';

export const searchFeeApplicableProducts = querySearch(GET_FEE_APPLICABLE_PRODUCTS_URL, SEARCH_FEE_APPLICABLE_PRODUCTS,
  SEARCH_FEE_APPLICABLE_PRODUCTS_COMPLETED, SEARCH_FEE_APPLICABLE_PRODUCTS_FAILED, ['productDisplay']);

function extraQueryParams({filters, searchFilter}) {
  const {dispensaryId} = filters;
  return {dispensaryId, terms: searchFilter};
}

const FEE_SEARCH_PRODUCTS_URL = `${process.env.PUBLIC_URL}/api/v1/product/searchProduct`;
export const FEE_SEARCH_PRODUCTS = 'FEE_SEARCH_PRODUCTS';
export const FEE_SEARCH_PRODUCTS_COMPLETED = 'FEE_SEARCH_PRODUCTS_COMPLETED';
export const FEE_SEARCH_PRODUCTS_FAILED = 'FEE_SEARCH_PRODUCTS_FAILED';
export const searchProducts = querySearch(FEE_SEARCH_PRODUCTS_URL, FEE_SEARCH_PRODUCTS, FEE_SEARCH_PRODUCTS_COMPLETED,
  FEE_SEARCH_PRODUCTS_FAILED, ['display'], {extraQueryParams});

export const ADD_APPLICABLE_PRODUCT_FOR_FEE = 'ADD_APPLICABLE_PRODUCT_FOR_FEE';
export const ADD_APPLICABLE_PRODUCT_FOR_FEE_COMPLETED = 'ADD_APPLICABLE_PRODUCT_FOR_FEE_COMPLETED';
export const ADD_APPLICABLE_PRODUCT_FOR_FEE_FAILED = 'ADD_APPLICABLE_PRODUCT_FOR_FEE_FAILED';
export const addApplicableProductForFee = command(FEE_ACTION_URL + '/addApplicableProduct',
  ADD_APPLICABLE_PRODUCT_FOR_FEE, ADD_APPLICABLE_PRODUCT_FOR_FEE_COMPLETED, ADD_APPLICABLE_PRODUCT_FOR_FEE_FAILED);

export const REMOVE_APPLICABLE_PRODUCT_FOR_FEE = 'REMOVE_APPLICABLE_PRODUCT_FOR_FEE';
export const REMOVE_APPLICABLE_PRODUCT_FOR_FEE_COMPLETED = 'REMOVE_APPLICABLE_PRODUCT_FOR_FEE_COMPLETED';
export const REMOVE_APPLICABLE_PRODUCT_FOR_FEE_FAILED = 'REMOVE_APPLICABLE_PRODUCT_FOR_FEE_FAILED';
export const removeApplicableProductForFee = command(FEE_ACTION_URL + '/removeApplicableProduct',
  REMOVE_APPLICABLE_PRODUCT_FOR_FEE, REMOVE_APPLICABLE_PRODUCT_FOR_FEE_COMPLETED, REMOVE_APPLICABLE_PRODUCT_FOR_FEE_FAILED);



// WEBPACK FOOTER //
// ./src/Fee/actions.js